export default __webpack_public_path__ + "static/media/users_5.8c4bf454.png";